import React from "react";
import { useContent } from "../contexts/ContentContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export default function FAQ() {
    const { t } = useContent();
    const items = t?.faq?.items || [];

    return (
        <section id="faq" className="relative py-24 md:py-40 bg-white" data-testid="faq-section">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="kicker">{t?.faq?.kicker}</span>
                    <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl text-brand-navy leading-[1.05]" data-testid="faq-title">
                        {t?.faq?.title}
                    </h2>
                </div>

                <Accordion type="single" collapsible className="w-full">
                    {items.map((item, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-b border-brand-navy/10 last:border-b-0"
                        >
                            <AccordionTrigger
                                className="text-left font-display text-xl md:text-2xl text-brand-navy hover:text-brand-terracotta py-6 hover:no-underline"
                                data-testid={`faq-trigger-${i}`}
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-base md:text-lg text-slate-600 leading-relaxed pb-8" data-testid={`faq-content-${i}`}>
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
